const colors = {
  background: {
    default: "#f4fbeed5", // Light green background
  },

  text: {
  main: "#206d1a",
  focus: "#599c16",
  secondary: "#83b36d",
},

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#2f2f2f",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
  main: "#599c16",   //  match sidenav active
  focus: "#206d1a",
},

  //  SECONDARY (Muted UI)
  secondary: {
    main: "#83b36d",
    focus: "#549247",
  },

  //  INFO (Keep slightly different for contrast)
  info: {
    main: "#377d2f",
    focus: "#226e1b",
  },

  success: {
    main: "#549247",
    focus: "#226e1b",
  },

  warning: {
    main: "#fbcf33",
    focus: "#f59e0b",
  },

  error: {
    main: "#ea0606",
    focus: "#c70505",
  },

  light: {
    main: "#ecffc7",
    focus: "#f5ffe0",
  },

  //  SIDEBAR / DARK AREAS
  dark: {
  main: "#206d1a",   //  sidebar base
  focus: "#145214",
},

  grey: {
    100: "#f8fafc",
    200: "#f1f5f9",
    300: "#e2e8f0",
    400: "#cbd5e1",
    500: "#94a3b8",
    600: "#64748b",
    700: "#475569",
    800: "#334155",
    900: "#1e293b",
  },

  //  GRADIENTS (modern UI feel)
  gradients: {
    primary: {
      main: "#226e1b",
      state: "#549247",
    },

    secondary: {
      main: "#83b36d",
      state: "#b7d89a",
    },

    info: {
      main: "#377d2f",
      state: "#83b36d",
    },

    success: {
      main: "#549247",
      state: "#b7d89a",
    },

    warning: {
      main: "#fbcf33",
      state: "#f59e0b",
    },

    error: {
      main: "#ea0606",
      state: "#ff667c",
    },

    light: {
      main: "#ecffc7",
      state: "#f5ffe0",
    },

    dark: {
      main: "#226e1b",
      state: "#377d2f",
    },
  },

  //  ALERT COLORS (match brand)
  alertColors: {
    primary: {
      main: "#226e1b",
      state: "#549247",
      border: "#b7d89a",
    },

    secondary: {
      main: "#83b36d",
      state: "#549247",
      border: "#d6eecf",
    },

    info: {
      main: "#377d2f",
      state: "#83b36d",
      border: "#b7d89a",
    },

    success: {
      main: "#549247",
      state: "#226e1b",
      border: "#b7d89a",
    },

    warning: {
      main: "#fbcf33",
      state: "#f59e0b",
      border: "#fef1c2",
    },

    error: {
      main: "#ea0606",
      state: "#ff3d59",
      border: "#f9b4b4",
    },

    light: {
      main: "#ecffc7",
      state: "#f5ffe0",
      border: "#ffffff",
    },

    dark: {
      main: "#226e1b",
      state: "#377d2f",
      border: "#83b36d",
    },
  },

  //  BADGES
  badgeColors: {
    primary: {
      background: "#b7d89a",
      text: "#226e1b",
    },

    secondary: {
      background: "#ecffc7",
      text: "#549247",
    },

    success: {
      background: "#dff7c0",
      text: "#226e1b",
    },

    warning: {
      background: "#fef5d3",
      text: "#fbc400",
    },

    error: {
      background: "#fc9797",
      text: "#bd0000",
    },

    light: {
      background: "#ffffff",
      text: "#83b36d",
    },

    dark: {
      background: "#549247",
      text: "#ffffff",
    },
  },

  inputColors: {
    borderColor: {
      main: "#d2d6da",
      focus: "#226e1b",
    },
    boxShadow: "rgba(34, 110, 27, 0.25)",
    error: "#fd5c70",
    success: "#226e1b",
  },

  sliderColors: {
    thumb: { borderColor: "#d9d9d9" },
  },

  circleSliderColors: {
    background: "#d3d3d3",
  },

  tabs: {
    indicator: { boxShadow: "#226e1b" },
  },
};

export default colors;